var _path, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTickGreen = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 19.6875C15.3503 19.6875 19.6875 15.3503 19.6875 10C19.6875 4.64973 15.3503 0.3125 10 0.3125C4.64973 0.3125 0.3125 4.64973 0.3125 10C0.3125 15.3503 4.64973 19.6875 10 19.6875ZM16.067 7.943L8.87945 15.1305C8.63535 15.3746 8.23965 15.3746 7.99555 15.1305L3.93305 11.068C3.68898 10.8239 3.68898 10.4282 3.93305 10.1841L4.81691 9.30022C5.06102 9.05616 5.45676 9.05616 5.70082 9.30022L8.4375 12.0369L14.2992 6.17526C14.5433 5.93116 14.939 5.93116 15.1831 6.17526L16.067 7.05913C16.311 7.30319 16.311 7.69894 16.067 7.943Z",
    fill: "#007D05"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 19.6875C15.3503 19.6875 19.6875 15.3503 19.6875 10C19.6875 4.64973 15.3503 0.3125 10 0.3125C4.64973 0.3125 0.3125 4.64973 0.3125 10C0.3125 15.3503 4.64973 19.6875 10 19.6875ZM16.067 7.943L8.87945 15.1305C8.63535 15.3746 8.23965 15.3746 7.99555 15.1305L3.93305 11.068C3.68898 10.8239 3.68898 10.4282 3.93305 10.1841L4.81691 9.30022C5.06102 9.05616 5.45676 9.05616 5.70082 9.30022L8.4375 12.0369L14.2992 6.17526C14.5433 5.93116 14.939 5.93116 15.1831 6.17526L16.067 7.05913C16.311 7.30319 16.311 7.69894 16.067 7.943Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#1BB55C"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTickGreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tick_green.6c110f57924835966e7a19ad6305156d.svg";